<h2 mat-dialog-title>
    <mat-icon style="margin-right: 8px; vertical-align: middle;">auto_graph</mat-icon>
    Historical Data
</h2>
<mat-dialog-content>
    <div *ngIf="loading" class="history-loading">
        <mat-spinner diameter="40"></mat-spinner>
        <p>Loading historical data for {{ getMetricDisplayName(data.metric) }}</p>
        <p style="font-size: 12px; margin-top: 8px; opacity: 0.7;">{{ data.dateRange }} view</p>
    </div>
    <div *ngIf="error" class="history-error">
        <mat-icon color="warn">error_outline</mat-icon>
        <p>Unable to load historical data</p>
        <p style="font-size: 12px; margin-top: 8px; opacity: 0.7;">Please try again later</p>
    </div>
    <div *ngIf="!loading && !error && hasValidData" class="history-chart-container">
        <!-- Single series line chart -->
        <ngx-charts-line-chart *ngIf="!isMultiSeries && isLineChart" class="ngx-chart" [results]="lineChartData" [xAxis]="true" [yAxis]="true"
            [showXAxisLabel]="true" [showYAxisLabel]="true" [xAxisLabel]="'Period'" [yAxisLabel]="yAxisLabel"
            [scheme]="isRateMetric(data.metric) ? rateChartColorScheme : lineChartColorScheme" [animations]="true" [legend]="false" [gradient]="false" [autoScale]="true">
        </ngx-charts-line-chart>
        
        <!-- Single series bar chart -->
        <ngx-charts-bar-vertical *ngIf="!isMultiSeries && !isLineChart" class="ngx-chart" [results]="chartData" [xAxis]="true" [yAxis]="true"
            [showXAxisLabel]="true" [showYAxisLabel]="true" [xAxisLabel]="'Period'" [yAxisLabel]="yAxisLabel"
            [scheme]="'vivid'" [roundEdges]="true" [animations]="true" [showDataLabel]="true" [legend]="false">
        </ngx-charts-bar-vertical>
        
        <!-- Multi-series grouped vertical bar chart -->
        <ngx-charts-bar-vertical-2d *ngIf="isMultiSeries" class="ngx-chart" [results]="multiChartData" [xAxis]="true" [yAxis]="true"
            [showXAxisLabel]="true" [showYAxisLabel]="true" [xAxisLabel]="'Period'" [yAxisLabel]="yAxisLabel"
            [scheme]="'vivid'" [animations]="false" [legend]="true" [gradient]="false">
        </ngx-charts-bar-vertical-2d>
    </div>
    <div *ngIf="!loading && !error && chartData.length === 0 && multiChartData.length === 0" class="history-no-data">
        <mat-icon>info_outline</mat-icon>
        <p>No historical data available</p>
        <p style="font-size: 12px; margin-top: 8px; opacity: 0.7;">Try selecting a different date range</p>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>